module.exports = __webpack_public_path__ + "img/succ.7d2e1e3b.png";